import GlobalConstants from "../components/GlobalConstants";

const brands = [
  {
    "key": "aden-n-anais",
    "name": "Aden & Anais",
    "logo": "aden-n-anais.png",
    "amazon": GlobalConstants.FILTER_UNAVAILABLE,
    "sizes": [
      { "size": "0-3 Months",  "minHeight": 19, "maxHeight": 23, "minWeight": 8, "maxWeight": 12 },
      { "size": "3-6 Months",  "minHeight": 23, "maxHeight": 25, "minWeight": 12, "maxWeight": 17 },
      { "size": "6-9 Months",  "minHeight": 25, "maxHeight": 27, "minWeight": 17, "maxWeight": 20 },
      { "size": "9-12 Months", "minHeight": 27, "maxHeight": 29, "minWeight": 20, "maxWeight": 23 },
    ]
  },
  {
    "key": "burts-bees-baby",
    "name": "Burt's Bees Baby",
    "logo": "burts-bees-baby.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Preemie",       "minHeight": 0,    "maxHeight": 18,   "minWeight": 0,  "maxWeight": 7 },
      { "size": "0 to 3 months", "minHeight": 18,   "maxHeight": 24,   "minWeight": 7,  "maxWeight": 12 },
      { "size": "3 to 6 months", "minHeight": 24,   "maxHeight": 27,   "minWeight": 12, "maxWeight": 16 },
      { "size": "6 to 9 months", "minHeight": 27,   "maxHeight": 29,   "minWeight": 16, "maxWeight": 20 },
      { "size": "0 to 9 months", "minHeight": 0,    "maxHeight": 29,   "minWeight": 0,  "maxWeight": 20 },
      { "size": "12 months",     "minHeight": 28,   "maxHeight": 29.5, "minWeight": 20, "maxWeight": 21 },
      { "size": "18 months",     "minHeight": 29.5, "maxHeight": 32.5, "minWeight": 21, "maxWeight": 24 },
      { "size": "24 months",     "minHeight": 32.5, "maxHeight": 35.5, "minWeight": 24, "maxWeight": 28 },
      { "size": "2T",            "minHeight": 33,   "maxHeight": 36,   "minWeight": 24, "maxWeight": 28 },
      { "size": "3T",            "minHeight": 36,   "maxHeight": 38.5, "minWeight": 28, "maxWeight": 32 },
      { "size": "4T",            "minHeight": 39,   "maxHeight": 41.5, "minWeight": 32, "maxWeight": 36 },
      { "size": "5",             "minHeight": 42,   "maxHeight": 44.5, "minWeight": 36, "maxWeight": 42 },
      { "size": "6",             "minHeight": 45,   "maxHeight": 47.5, "minWeight": 42, "maxWeight": 48 },
      { "size": "6X",            "minHeight": 48,   "maxHeight": 50,   "minWeight": 48, "maxWeight": 50 },
      { "size": "7",             "minHeight": 48,   "maxHeight": 51.5, "minWeight": 50, "maxWeight": 53 },
    ]
  },
  {
    "key": "carters",
    "name": "Carter's",
    "logo": "carters.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Preemie",   "minHeight": 0,    "maxHeight": 17,   "minWeight": 0,    "maxWeight": 5 },
      { "size": "Newborn",   "minHeight": 0,    "maxHeight": 21.5, "minWeight": 5,    "maxWeight": 8 },
      { "size": "3 Months",  "minHeight": 21.5, "maxHeight": 24,   "minWeight": 8,    "maxWeight": 12.5 },
      { "size": "6 Months",  "minHeight": 24,   "maxHeight": 26.5, "minWeight": 12.5, "maxWeight": 16.5 },
      { "size": "9 Months",  "minHeight": 26.5, "maxHeight": 28.5, "minWeight": 16.5, "maxWeight": 20.5 },
      { "size": "12 Months", "minHeight": 28.5, "maxHeight": 30.5, "minWeight": 20.5, "maxWeight": 24.5 },
      { "size": "18 Months", "minHeight": 30.5, "maxHeight": 32.5, "minWeight": 24.5, "maxWeight": 27.5 },
      { "size": "24 Months", "minHeight": 32.5, "maxHeight": 34,   "minWeight": 27.5, "maxWeight": 30 },
      { "size": "2T",        "minHeight": 34,   "maxHeight": 36.5, "minWeight": 29,   "maxWeight": 31 },
      { "size": "3T",        "minHeight": 36.5, "maxHeight": 38.5, "minWeight": 31,   "maxWeight": 34 },
      { "size": "4T",        "minHeight": 38.5, "maxHeight": 41.5, "minWeight": 34,   "maxWeight": 38 },
      { "size": "5T",        "minHeight": 41.5, "maxHeight": 43.5, "minWeight": 38,   "maxWeight": 42 },
    ]
  },
  {
    "key": "cat-and-jack",
    "name": "Cat & Jack",
    "logo": "cat-and-jack.png",
    "amazon": GlobalConstants.BRAND_UNAVAILABLE,
    "sizes": [
      { "size": "Preemie",        "minWeight": 0,    "maxWeight": 5.5,  "minHeight": 0,    "maxHeight": 17.5 },
      { "size": "Newborn",        "minWeight": 6,    "maxWeight": 8,    "minHeight": 18,   "maxHeight": 20 },
      { "size": "0 to 3 Months",  "minWeight": 9,    "maxWeight": 12,   "minHeight": 20.5, "maxHeight": 23.5 },
      { "size": "3 to 6 Months",  "minWeight": 12.5, "maxWeight": 16,   "minHeight": 24,   "maxHeight": 25.5 },
      { "size": "6 to 9 Months",  "minWeight": 16.5, "maxWeight": 19.5, "minHeight": 26,   "maxHeight": 27.5 },
      { "size": "9 to 12 Months", "minWeight": 20,   "maxWeight": 23,   "minHeight": 28,   "maxHeight": 30.5 },
      { "size": "18 Months",      "minWeight": 23.5, "maxWeight": 26,   "minHeight": 31,   "maxHeight": 32.5 },
      { "size": "24 Months",      "minWeight": 26.5, "maxWeight": 28,   "minHeight": 33,   "maxHeight": 35.5 },
    ]
  },
  {
    "key": "calvin-klein",
    "name": "Calvin Klein",
    "logo": "calvin-klein.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Newborn",   "minHeight": 18.5, "maxHeight": 22,   "minWeight":  6,   "maxWeight":  9.5 },
      { "size": "3 Months",  "minHeight": 22.5, "maxHeight": 24,   "minWeight": 10,   "maxWeight": 14.5 },
      { "size": "6 Months",  "minHeight": 24.5, "maxHeight": 27,   "minWeight": 15,   "maxWeight": 18 },
      { "size": "9 Months",  "minHeight": 27.5, "maxHeight": 29,   "minWeight": 18.5, "maxWeight": 22 },
      { "size": "12 Months", "minHeight": 29.5, "maxHeight": 30.5, "minWeight": 22.5, "maxWeight": 25 },
      { "size": "18 Months", "minHeight": 31,   "maxHeight": 33,   "minWeight": 25.5, "maxWeight": 28 },
      { "size": "24 Months", "minHeight": 33.5, "maxHeight": 35.5, "minWeight": 28.5, "maxWeight": 30 },
      { "size": "2T",        "minHeight": 33.5, "maxHeight": 35.5, "minWeight": 25,   "maxWeight": 28 },
      { "size": "3T",        "minHeight": 36,   "maxHeight": 38.5, "minWeight": 29,   "maxWeight": 32 },
      { "size": "4T",        "minHeight": 39,   "maxHeight": 41.5, "minWeight": 33,   "maxWeight": 36 },
    ]
  },
  {
    "key": "cherokee",
    "name": "Cherokee",
    "logo": "cherokee.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Preemie",      "minWeight": 0,    "maxWeight": 5.5,  "minHeight": 0,    "maxHeight": 17.5 },
      { "size": "Newborn",      "minWeight": 6,    "maxWeight": 8.5,  "minHeight": 18,   "maxHeight": 20 },
      { "size": "3 Months",     "minWeight": 9,    "maxWeight": 12,   "minHeight": 20.5, "maxHeight": 23.5 },
      { "size": "6 Months",     "minWeight": 12.5, "maxWeight": 16,   "minHeight": 24,   "maxHeight": 25.5 },
      { "size": "9 Months",     "minWeight": 16.5, "maxWeight": 19.5, "minHeight": 26,   "maxHeight": 27.5 },
      { "size": "12 Months",    "minWeight": 20,   "maxWeight": 23,   "minHeight": 28,   "maxHeight": 30.5 },
      { "size": "18 Months",    "minWeight": 23.5, "maxWeight": 26,   "minHeight": 31,   "maxHeight": 32.5 },
      { "size": "24 Months/2T", "minWeight": 26.5, "maxWeight": 28,   "minHeight": 33,   "maxHeight": 35.5 },
      { "size": "3T",           "minWeight": 28.5, "maxWeight": 32,   "minHeight": 36,   "maxHeight": 38.5 },
      { "size": "4T",           "minWeight": 32.5, "maxWeight": 37,   "minHeight": 39,   "maxHeight": 43 },
      { "size": "5T",           "minWeight": 37.5, "maxWeight": 42,   "minHeight": 43,   "maxHeight": 44.5 },
    ]
  },
  {
    "key": "child-of-mine",
    "name": "Child of Mine",
    "logo": "child-of-mine.png",
    "amazon": GlobalConstants.FILTER_UNAVAILABLE,
    "sizes": [
      { "size": "Preemie",   "minHeight": 0,    "maxHeight": 17,   "minWeight": 0,    "maxWeight": 5 },
      { "size": "Newborn",   "minHeight": 0,    "maxHeight": 21.5, "minWeight": 5,    "maxWeight": 8 },
      { "size": "3 Months",  "minHeight": 21.5, "maxHeight": 24,   "minWeight": 8,    "maxWeight": 12.5 },
      { "size": "6 Months",  "minHeight": 24,   "maxHeight": 26.5, "minWeight": 12.5, "maxWeight": 16.5 },
      { "size": "9 Months",  "minHeight": 26.5, "maxHeight": 28.5, "minWeight": 16.5, "maxWeight": 20.5 },
      { "size": "12 Months", "minHeight": 28.5, "maxHeight": 30.5, "minWeight": 20.5, "maxWeight": 24.5 },
      { "size": "18 Months", "minHeight": 30.5, "maxHeight": 32.5, "minWeight": 24.5, "maxWeight": 27.5 },
      { "size": "24 Months", "minHeight": 32.5, "maxHeight": 34,   "minWeight": 27.5, "maxWeight": 30 },
      { "size": "2T",        "minHeight": 34,   "maxHeight": 36.5, "minWeight": 29,   "maxWeight": 31 },
      { "size": "3T",        "minHeight": 36.5, "maxHeight": 38.5, "minWeight": 31,   "maxWeight": 34 },
      { "size": "4T",        "minHeight": 38.5, "maxHeight": 41.5, "minWeight": 34,   "maxWeight": 38 },
      { "size": "5T",        "minHeight": 41.5, "maxHeight": 43.5, "minWeight": 38,   "maxWeight": 42 },
    ]
  },
  {
    "key": "the-childrens-place",
    "name": "The Children's Place",
    "logo": "the-childrens-place.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Newborn",         "minHeight": 0,    "maxHeight": 20.5, "minWeight": 0,  "maxWeight": 7 },
      { "size": "0 to 3 Months",   "minHeight": 20.5, "maxHeight": 24,   "minWeight": 7,  "maxWeight": 14 },
      { "size": "3 to 6 Months",   "minHeight": 24,   "maxHeight": 27,   "minWeight": 14, "maxWeight": 18 },
      { "size": "6 to 9 Months",   "minHeight": 27,   "maxHeight": 29,   "minWeight": 18, "maxWeight": 22 },
      { "size": "9 to 12 Months",  "minHeight": 29,   "maxHeight": 30.5, "minWeight": 22, "maxWeight": 26 },
      { "size": "12 to 18 Months", "minHeight": 30.5, "maxHeight": 32,   "minWeight": 26, "maxWeight": 28 },
      { "size": "18 to 24 Months", "minHeight": 32,   "maxHeight": 33.5, "minWeight": 28, "maxWeight": 30 },
      { "size": "2T",              "minHeight": 33.5, "maxHeight": 35,   "minWeight": 30, "maxWeight": 32 },
      { "size": "3T",              "minHeight": 35,   "maxHeight": 38,   "minWeight": 32, "maxWeight": 35 },
      { "size": "4T",              "minHeight": 38,   "maxHeight": 41,   "minWeight": 35, "maxWeight": 39 },
      { "size": "5T",              "minHeight": 41,   "maxHeight": 44,   "minWeight": 39, "maxWeight": 45 },
    ]
  },
  {
    "key": "circo",
    "name": "Circo",
    "logo": "circo.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Preemie",      "minWeight": 0,    "maxWeight": 5.5,  "minHeight": 0,    "maxHeight": 17.5 },
      { "size": "Newborn",      "minWeight": 6,    "maxWeight": 8.5,  "minHeight": 18,   "maxHeight": 20 },
      { "size": "3 Months",     "minWeight": 9,    "maxWeight": 12,   "minHeight": 20.5, "maxHeight": 23.5 },
      { "size": "6 Months",     "minWeight": 12.5, "maxWeight": 16,   "minHeight": 24,   "maxHeight": 25.5 },
      { "size": "9 Months",     "minWeight": 16.5, "maxWeight": 19.5, "minHeight": 26,   "maxHeight": 27.5 },
      { "size": "12 Months",    "minWeight": 19.5, "maxWeight": 23,   "minHeight": 28,   "maxHeight": 30.5 },
      { "size": "18 Months",    "minWeight": 23.5, "maxWeight": 26,   "minHeight": 31,   "maxHeight": 32.5 },
      { "size": "24 Months/2T", "minWeight": 26.5, "maxWeight": 28,   "minHeight": 33,   "maxHeight": 35.5 },
      { "size": "3T",           "minWeight": 28.5, "maxWeight": 32,   "minHeight": 36,   "maxHeight": 38.5 },
      { "size": "4T",           "minWeight": 32.5, "maxWeight": 37,   "minHeight": 39,   "maxHeight": 43 },
      { "size": "5T",           "minWeight": 37.5, "maxWeight": 42,   "minHeight": 43,   "maxHeight": 44.5 },
    ]
  },
  {
    "key": "faded-glory",
    "name": "Faded Glory",
    "logo": "faded-glory.jpg",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Preemie",       "minHeight": 0,    "maxHeight": 17,   "minWeight": 0,    "maxWeight": 5 },
      { "size": "Newborn",       "minHeight": 17.5, "maxHeight": 21,   "minWeight": 5.5,  "maxWeight": 7.5 },
      { "size": "0 to 3 Months", "minHeight": 20.5, "maxHeight": 23,   "minWeight": 6.5,  "maxWeight": 12 },
      { "size": "3 to 6 Months", "minHeight": 23.5, "maxHeight": 26,   "minWeight": 12.5, "maxWeight": 16 },
      { "size": "6 to 9 Months", "minHeight": 26.5, "maxHeight": 27.5, "minWeight": 16.5, "maxWeight": 19 },
      { "size": "12 Month",      "minHeight": 28,   "maxHeight": 29.5, "minWeight": 19.5, "maxWeight": 22 },
      { "size": "18 Month",      "minHeight": 30,   "maxHeight": 31.5, "minWeight": 22.5, "maxWeight": 26 },
      { "size": "24 Month",      "minHeight": 32,   "maxHeight": 33.5, "minWeight": 26.5, "maxWeight": 30 },
      { "size": "2T",            "minHeight": 32,   "maxHeight": 33.5, "minWeight": 26.5, "maxWeight": 30 },
      { "size": "3T",            "minHeight": 34,   "maxHeight": 37.5, "minWeight": 20.5, "maxWeight": 34 },
      { "size": "4T",            "minHeight": 38,   "maxHeight": 41.5, "minWeight": 34.5, "maxWeight": 38 },
      { "size": "5T",            "minHeight": 42,   "maxHeight": 44.5, "minWeight": 38.5, "maxWeight": 42 },
    ]
  },
  {
    "key": "gap",
    "name": "GAP",
    "logo": "gap.png",
    "amazon": GlobalConstants.FILTER_UNAVAILABLE,
    "sizes": [
      { "size": "Newborn",         "minHeight": 0,  "maxHeight": 18, "minWeight": 0,  "maxWeight": 7 },
      { "size": "0 to 3 Months",   "minHeight": 18, "maxHeight": 23, "minWeight": 7,  "maxWeight": 12, "amazonSearch": "0-3 Months" },
      { "size": "3 to 6 Months",   "minHeight": 23, "maxHeight": 27, "minWeight": 12, "maxWeight": 17, "amazonSearch": "3-6 Months" },
      { "size": "6 to 12 Months",  "minHeight": 27, "maxHeight": 29, "minWeight": 17, "maxWeight": 22, "amazonSearch": "6-12 Months" },
      { "size": "12 to 18 Months", "minHeight": 29, "maxHeight": 31, "minWeight": 22, "maxWeight": 27, "amazonSearch": "12-18 Months" },
      { "size": "18 to 24 Months", "minHeight": 31, "maxHeight": 33, "minWeight": 27, "maxWeight": 30, "amazonSearch": "18-24 Months" },
      { "size": "2 Years",         "minHeight": 33, "maxHeight": 36, "minWeight": 30, "maxWeight": 33 },
      { "size": "3 Years",         "minHeight": 36, "maxHeight": 39, "minWeight": 33, "maxWeight": 36 },
      { "size": "4 Years",         "minHeight": 39, "maxHeight": 42, "minWeight": 36, "maxWeight": 40 },
      { "size": "5 Years",         "minHeight": 42, "maxHeight": 45, "minWeight": 40, "maxWeight": 46 },
    ]
  },
  {
    "key": "garanimals",
    "name": "Garanimals",
    "logo": "garanimals.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "0 to 3 Months", "minHeight": 20.5, "maxHeight": 23,   "minWeight": 6.5,  "maxWeight": 12 },
      { "size": "3 to 6 Months", "minHeight": 23.5, "maxHeight": 26,   "minWeight": 12.5, "maxWeight": 16 },
      { "size": "6 to 9 Months", "minHeight": 26.5, "maxHeight": 27.5, "minWeight": 16.5, "maxWeight": 19 },
      { "size": "12 Month",      "minHeight": 28,   "maxHeight": 29.5, "minWeight": 19.5, "maxWeight": 22 },
      { "size": "18 Month",      "minHeight": 30,   "maxHeight": 31.5, "minWeight": 22.5, "maxWeight": 26 },
      { "size": "24 Month",      "minHeight": 32,   "maxHeight": 33.5, "minWeight": 26.5, "maxWeight": 30 },
      { "size": "2T",            "minHeight": 32,   "maxHeight": 33.5, "minWeight": 26.5, "maxWeight": 30 },
      { "size": "3T",            "minHeight": 34,   "maxHeight": 37.5, "minWeight": 30.5, "maxWeight": 34 },
      { "size": "4T",            "minHeight": 38,   "maxHeight": 41.5, "minWeight": 34.5, "maxWeight": 38 },
      { "size": "5T",            "minHeight": 42,   "maxHeight": 44.5, "minWeight": 38.5, "maxWeight": 42 },
    ]
  },
  {
    "key": "gerber",
    "name": "Gerber",
    "logo": "gerber.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Newborn",       "minHeight": 17, "maxHeight": 21, "minWeight": 5,  "maxWeight": 8 },
      { "size": "0 to 3 Months", "minHeight": 21, "maxHeight": 24, "minWeight": 8,  "maxWeight": 12 },
      { "size": "0 to 6 Months", "minHeight": 0,  "maxHeight": 26, "minWeight": 0,  "maxWeight": 16 },
      { "size": "3 to 6 Months", "minHeight": 24, "maxHeight": 26, "minWeight": 12, "maxWeight": 16 },
      { "size": "3 to 9 Months", "minHeight": 24, "maxHeight": 28, "minWeight": 12, "maxWeight": 20 },
      { "size": "6 to 9 Months", "minHeight": 26, "maxHeight": 28, "minWeight": 16, "maxWeight": 20 },
      { "size": "12 Months",	   "minHeight": 28, "maxHeight": 30, "minWeight": 20, "maxWeight": 24 },
      { "size": "18 Months",	   "minHeight": 30, "maxHeight": 32, "minWeight": 24, "maxWeight": 28 },
      { "size": "24 Months, 2T", "minHeight": 32, "maxHeight": 34, "minWeight": 28, "maxWeight": 32 },
      { "size": "3T",            "minHeight": 34, "maxHeight": 38, "minWeight": 32, "maxWeight": 35 },
      { "size": "4T",            "minHeight": 38, "maxHeight": 40, "minWeight": 35, "maxWeight": 39 },
    ]
  },
  {
    "key": "gymboree",
    "name": "Gymboree",
    "logo": "gymboree.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Newborn",         "minHeight": 0,  "maxHeight": 19, "minWeight": 0,  "maxWeight": 8 },
      { "size": "0 to 3 Months",   "minHeight": 19, "maxHeight": 23, "minWeight": 8,  "maxWeight": 12 },
      { "size": "3 to 6 Months",   "minHeight": 23, "maxHeight": 25, "minWeight": 12, "maxWeight": 17 },
      { "size": "6 to 9 Months",   "minHeight": 25, "maxHeight": 27, "minWeight": 17, "maxWeight": 19.5 },
      { "size": "6 to 12 Months",  "minHeight": 25, "maxHeight": 29, "minWeight": 17, "maxWeight": 22 },
      { "size": "12 to 18 Months", "minHeight": 29, "maxHeight": 31, "minWeight": 22, "maxWeight": 27 },
      { "size": "18 to 24 Months", "minHeight": 31, "maxHeight": 33, "minWeight": 27, "maxWeight": 30 },
      { "size": "2 Years",         "minHeight": 33, "maxHeight": 36, "minWeight": 30, "maxWeight": 33 },
      { "size": "3 Years",         "minHeight": 36, "maxHeight": 39, "minWeight": 33, "maxWeight": 36 },
      { "size": "4 Years",         "minHeight": 39, "maxHeight": 42, "minWeight": 36, "maxWeight": 40 },
      { "size": "5 Years",         "minHeight": 42, "maxHeight": 45, "minWeight": 40, "maxWeight": 44 },
    ]
  },
  {
    "key": "hnm",
    "name": "H&M",
    "logo": "hnm.png",
    "amazon": GlobalConstants.FILTER_UNAVAILABLE,
    "sizes": [
      { "size": "0 Month",       "minHeight":  0, "maxHeight": 17, "minWeight": 0, "maxWeight": 9999 },
      { "size": "0-1 Months",    "minHeight": 17, "maxHeight": 20, "minWeight": 0, "maxWeight": 9999 },
      { "size": "1-2 Months",    "minHeight": 20, "maxHeight": 22, "minWeight": 0, "maxWeight": 9999 },
      { "size": "2-4 Months",    "minHeight": 22, "maxHeight": 24, "minWeight": 0, "maxWeight": 9999 },
      { "size": "4-6 Months",    "minHeight": 24, "maxHeight": 27, "minWeight": 0, "maxWeight": 9999 },
      { "size": "6-9 Months",    "minHeight": 27, "maxHeight": 29, "minWeight": 0, "maxWeight": 9999 },
      { "size": "9-12 Months",   "minHeight": 29, "maxHeight": 31, "minWeight": 0, "maxWeight": 9999 },
      { "size": "12-18 Months",  "minHeight": 31, "maxHeight": 34, "minWeight": 0, "maxWeight": 9999 },
      { "size": "18-24 Months",  "minHeight": 34, "maxHeight": 36, "minWeight": 0, "maxWeight": 9999 },
      { "size": "1 1/2-2 Years", "minHeight": 34, "maxHeight": 36, "minWeight": 0, "maxWeight": 9999 },
      { "size": "2-3 Years",     "minHeight": 36, "maxHeight": 39, "minWeight": 0, "maxWeight": 9999 },
      { "size": "3-4 Years",     "minHeight": 39, "maxHeight": 41, "minWeight": 0, "maxWeight": 9999 },
      { "size": "4-5 Years",     "minHeight": 41, "maxHeight": 43, "minWeight": 0, "maxWeight": 9999 },
      { "size": "5-6 Years",     "minHeight": 43, "maxHeight": 46, "minWeight": 0, "maxWeight": 9999 },
    ]
  },
  {
    "key": "hanna-andersson",
    "name": "Hanna Andersson",
    "logo": "hanna-andersson.png",
    "amazon": GlobalConstants.FILTER_UNAVAILABLE,
    "sizes": [
      { "size": "Newborn", "minHeight":  0, "maxHeight": 19, "minWeight":  0, "maxWeight":  8 },
      { "size": "50 cm",   "minHeight": 18, "maxHeight": 22, "minWeight":  8, "maxWeight": 12 },
      { "size": "60 cm",   "minHeight": 22, "maxHeight": 26, "minWeight": 12, "maxWeight": 16 },
      { "size": "70 cm",   "minHeight": 26, "maxHeight": 28, "minWeight": 16, "maxWeight": 20 },
      { "size": "75 cm",   "minHeight": 28, "maxHeight": 30, "minWeight": 20, "maxWeight": 24 },
      { "size": "80 cm",   "minHeight": 30, "maxHeight": 32, "minWeight": 24, "maxWeight": 27 },
      { "size": "85 cm",   "minHeight": 32, "maxHeight": 34, "minWeight": 27, "maxWeight": 30 },
      { "size": "90 cm",   "minHeight": 34, "maxHeight": 38, "minWeight": 26, "maxWeight": 33 },
      { "size": "100 cm",  "minHeight": 38, "maxHeight": 42, "minWeight": 31, "maxWeight": 38 },
      { "size": "110 cm",  "minHeight": 42, "maxHeight": 46, "minWeight": 37, "maxWeight": 48 },
    ]
  },
  {
    "key": "janie-and-jack",
    "name": "Janie & Jack",
    "logo": "janie-and-jack.png",
    "amazon": GlobalConstants.FILTER_UNAVAILABLE,
    "sizes": [
      { "size": "Newborn",         "minHeight": 0,  "maxHeight": 19, "minWeight": 0,  "maxWeight": 8 },
      { "size": "0 to 3 Months",   "minHeight": 19, "maxHeight": 23, "minWeight": 8,  "maxWeight": 12 },
      { "size": "3 to 6 Months",   "minHeight": 23, "maxHeight": 25, "minWeight": 12, "maxWeight": 17 },
      { "size": "6 to 12 Months",  "minHeight": 25, "maxHeight": 29, "minWeight": 17, "maxWeight": 22 },
      { "size": "12 to 18 Months", "minHeight": 29, "maxHeight": 31, "minWeight": 22, "maxWeight": 27 },
      { "size": "18 to 24 Months", "minHeight": 31, "maxHeight": 33, "minWeight": 27, "maxWeight": 30 },
      { "size": "2T",              "minHeight": 33, "maxHeight": 36, "minWeight": 30, "maxWeight": 33 },
      { "size": "3",               "minHeight": 36, "maxHeight": 39, "minWeight": 33, "maxWeight": 36 },
      { "size": "4",               "minHeight": 39, "maxHeight": 42, "minWeight": 36, "maxWeight": 40 },
      { "size": "5",               "minHeight": 42, "maxHeight": 45, "minWeight": 40, "maxWeight": 44 },
      { "size": "6",               "minHeight": 45, "maxHeight": 48, "minWeight": 44, "maxWeight": 52 },
      { "size": "7",               "minHeight": 48, "maxHeight": 51, "minWeight": 52, "maxWeight": 62 },
      { "size": "8",               "minHeight": 51, "maxHeight": 54, "minWeight": 62, "maxWeight": 74 },
      { "size": "10",              "minHeight": 54, "maxHeight": 58, "minWeight": 74, "maxWeight": 86 },
      { "size": "12",              "minHeight": 58, "maxHeight": 60, "minWeight": 86, "maxWeight": 98 },
    ]
  },
  {
    "key": "jumping-beans",
    "name": "Jumping Beans",
    "logo": "jumping-beans.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Newborn",   "minWeight": 0,  "maxWeight": 8,  "minHeight": 19, "maxHeight": 21 },
      { "size": "3 Months",  "minWeight": 8,  "maxWeight": 12, "minHeight": 21, "maxHeight": 23 },
      { "size": "6 Months",  "minWeight": 12, "maxWeight": 16, "minHeight": 23, "maxHeight": 25 },
      { "size": "9 Months",  "minWeight": 16, "maxWeight": 20, "minHeight": 25, "maxHeight": 27 },
      { "size": "12 Months", "minWeight": 20, "maxWeight": 23, "minHeight": 27, "maxHeight": 29 },
      { "size": "18 Months", "minWeight": 23, "maxWeight": 26, "minHeight": 29, "maxHeight": 31 },
      { "size": "24 Months", "minWeight": 26, "maxWeight": 29, "minHeight": 31, "maxHeight": 33 },
      { "size": "2T",        "minWeight": 29, "maxWeight": 30, "minHeight": 33, "maxHeight": 36 },
      { "size": "3T",        "minWeight": 30, "maxWeight": 33, "minHeight": 36, "maxHeight": 38 },
      { "size": "4T",        "minWeight": 33, "maxWeight": 36, "minHeight": 38, "maxHeight": 40 },
    ]
  },
  {
    "key": "just-one-you",
    "name": "Just One You",
    "logo": "just-one-you.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Preemie",   "minHeight": 0,    "maxHeight": 17,   "minWeight": 0,    "maxWeight": 5 },
      { "size": "Newborn",   "minHeight": 0,    "maxHeight": 21.5, "minWeight": 5,    "maxWeight": 8 },
      { "size": "3 Months",  "minHeight": 21.5, "maxHeight": 24,   "minWeight": 8,    "maxWeight": 12.5 },
      { "size": "6 Months",  "minHeight": 24,   "maxHeight": 26.5, "minWeight": 12.5, "maxWeight": 16.5 },
      { "size": "9 Months",  "minHeight": 26.5, "maxHeight": 28.5, "minWeight": 16.5, "maxWeight": 20.5 },
      { "size": "12 Months", "minHeight": 28.5, "maxHeight": 30.5, "minWeight": 20.5, "maxWeight": 24.5 },
      { "size": "18 Months", "minHeight": 30.5, "maxHeight": 32.5, "minWeight": 24.5, "maxWeight": 27.5 },
      { "size": "24 Months", "minHeight": 32.5, "maxHeight": 34,   "minWeight": 27.5, "maxWeight": 30 },
      { "size": "2T",        "minHeight": 34,   "maxHeight": 36.5, "minWeight": 29,   "maxWeight": 31 },
      { "size": "3T",        "minHeight": 36.5, "maxHeight": 38.5, "minWeight": 31,   "maxWeight": 34 },
      { "size": "4T",        "minHeight": 38.5, "maxHeight": 41.5, "minWeight": 34,   "maxWeight": 38 },
      { "size": "5T",        "minHeight": 41.5, "maxHeight": 43.5, "minWeight": 38,   "maxWeight": 42 },
    ]
  },
  {
    "key": "little-me",
    "name": "Little Me",
    "logo": "little-me.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Preemie",   "minHeight": 0,  "maxHeight": 18, "minWeight": 0,  "maxWeight": 5 },
      { "size": "Newborn",   "minHeight": 0,  "maxHeight": 21, "minWeight": 0,  "maxWeight": 8 },
      { "size": "3 months",  "minHeight": 0,  "maxHeight": 24, "minWeight": 0,  "maxWeight": 12 },
      { "size": "6 months",  "minHeight": 24, "maxHeight": 27, "minWeight": 12, "maxWeight": 16 },
      { "size": "9 months",  "minHeight": 27, "maxHeight": 29, "minWeight": 16, "maxWeight": 18 },
      { "size": "12 months", "minHeight": 29, "maxHeight": 31, "minWeight": 18, "maxWeight": 23 },
      { "size": "18 months", "minHeight": 31, "maxHeight": 33, "minWeight": 23, "maxWeight": 26 },
      { "size": "24 months", "minHeight": 33, "maxHeight": 35, "minWeight": 26, "maxWeight": 29 },
      { "size": "2T",        "minHeight": 33, "maxHeight": 35, "minWeight": 26, "maxWeight": 30 },
      { "size": "3T",        "minHeight": 35, "maxHeight": 38, "minWeight": 30, "maxWeight": 34 },
      { "size": "4T",        "minHeight": 38, "maxHeight": 41, "minWeight": 34, "maxWeight": 39 },
    ]
  },
  {
    "key": "mud-pie",
    "name": "Mud Pie",
    "logo": "mud-pie.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "6 Months",  "minHeight": 24, "maxHeight": 27, "minWeight": 12, "maxWeight": 17 },
      { "size": "9 Months",  "minHeight": 27, "maxHeight": 29, "minWeight": 17, "maxWeight": 21 },
      { "size": "12 Months", "minHeight": 29, "maxHeight": 31, "minWeight": 21, "maxWeight": 25 },
      { "size": "18 Months", "minHeight": 31, "maxHeight": 33, "minWeight": 25, "maxWeight": 28 },
      { "size": "2T",        "minHeight": 35, "maxHeight": 37, "minWeight": 28, "maxWeight": 31 },
      { "size": "3T",        "minHeight": 37, "maxHeight": 39, "minWeight": 31, "maxWeight": 34 },
      { "size": "4T",        "minHeight": 39, "maxHeight": 42, "minWeight": 34, "maxWeight": 38 },
      { "size": "5T",        "minHeight": 42, "maxHeight": 44, "minWeight": 38, "maxWeight": 42 },
    ]
  },
  {
    "key": "old-navy",
    "name": "Old Navy",
    "logo": "old-navy.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Newborn",         "minHeight": 0,  "maxHeight": 18,  "minWeight": 0,  "maxWeight": 7 },
      { "size": "0 to 3 Months",   "minHeight": 19, "maxHeight": 23,  "minWeight": 7,  "maxWeight": 12, "amazonSearch": "0-3 Months" },
      { "size": "3 to 6 Months",   "minHeight": 23, "maxHeight": 27,  "minWeight": 12, "maxWeight": 17, "amazonSearch": "3-6 Months" },
      { "size": "6 to 9 Months",   "minHeight": 27, "maxHeight": 28,  "minWeight": 17, "maxWeight": 19, "amazonSearch": "6-9 Months" },
      { "size": "6 to 12 Months",  "minHeight": 27, "maxHeight": 29,  "minWeight": 17, "maxWeight": 22, "amazonSearch": "6-12 Months" },
      { "size": "12 to 18 Months", "minHeight": 29, "maxHeight": 31,  "minWeight": 22, "maxWeight": 27, "amazonSearch": "12-18 Months" },
      { "size": "18 to 24 Months", "minHeight": 31, "maxHeight": 33,  "minWeight": 27, "maxWeight": 30, "amazonSearch": "18-24 Months" },
      { "size": "2 Years",         "minHeight": 33, "maxHeight": 36,  "minWeight": 30, "maxWeight": 33, "amazonSearch": "2T" },
      { "size": "3 Years",         "minHeight": 36, "maxHeight": 39,  "minWeight": 33, "maxWeight": 36, "amazonSearch": "3T" },
      { "size": "4 Years",         "minHeight": 39, "maxHeight": 42,  "minWeight": 36, "maxWeight": 40, "amazonSearch": "4T" },
      { "size": "5 Years",         "minHeight": 42, "maxHeight": 45,  "minWeight": 40, "maxWeight": 46, "amazonSearch": "5T" },
    ]
  },
  {
    "key": "osh-kosh",
    "name": "Osh Kosh",
    "logo": "osh-kosh.png",
    "amazon": GlobalConstants.FILTER_UNAVAILABLE,
    "sizes": [
      { "size": "Preemie",   "minHeight": 0,    "maxHeight": 17,   "minWeight": 0,    "maxWeight": 5 },
      { "size": "Newborn",   "minHeight": 0,    "maxHeight": 21.5, "minWeight": 5,    "maxWeight": 8 },
      { "size": "3 Months",  "minHeight": 21.5, "maxHeight": 24,   "minWeight": 8,    "maxWeight": 12.5 },
      { "size": "6 Months",  "minHeight": 24,   "maxHeight": 26.5, "minWeight": 12.5, "maxWeight": 16.5 },
      { "size": "9 Months",  "minHeight": 26.5, "maxHeight": 28.5, "minWeight": 16.5, "maxWeight": 20.5 },
      { "size": "12 Months", "minHeight": 28.5, "maxHeight": 30.5, "minWeight": 20.5, "maxWeight": 24.5 },
      { "size": "18 Months", "minHeight": 30.5, "maxHeight": 32.5, "minWeight": 24.5, "maxWeight": 27.5 },
      { "size": "24 Months", "minHeight": 32.5, "maxHeight": 34,   "minWeight": 27.5, "maxWeight": 30 },
      { "size": "2T",        "minHeight": 34,   "maxHeight": 36.5, "minWeight": 29,   "maxWeight": 31 },
      { "size": "3T",        "minHeight": 36.5, "maxHeight": 38.5, "minWeight": 31,   "maxWeight": 34 },
      { "size": "4T",        "minHeight": 38.5, "maxHeight": 41.5, "minWeight": 34,   "maxWeight": 38 },
      { "size": "5T",        "minHeight": 41.5, "maxHeight": 43.5, "minWeight": 38,   "maxWeight": 42 },
    ]
  },
  {
    "key": "quiksilver",
    "name": "Quiksilver",
    "logo": "quiksilver.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "12 Months", "minHeight": 27,   "maxHeight": 30.5, "minWeight": 0, "maxWeight": 9999 },
      { "size": "18 Months", "minHeight": 31,   "maxHeight": 33,   "minWeight": 0, "maxWeight": 9999 },
      { "size": "24 Months", "minHeight": 33.5, "maxHeight": 35.5, "minWeight": 0, "maxWeight": 9999 },
      { "size": "2T",        "minHeight": 33.5, "maxHeight": 35,   "minWeight": 0, "maxWeight": 9999 },
      { "size": "3T",        "minHeight": 35.5, "maxHeight": 39,   "minWeight": 0, "maxWeight": 9999 },
      { "size": "4T",        "minHeight": 39.5, "maxHeight": 41,   "minWeight": 0, "maxWeight": 9999 },
      { "size": "4",         "minHeight": 41.5, "maxHeight": 43,   "minWeight": 0, "maxWeight": 9999 },
      { "size": "5",         "minHeight": 43.5, "maxHeight": 46,   "minWeight": 0, "maxWeight": 9999 },
    ]
  },
  {
    "key": "ralph-lauren",
    "name": "Ralph Lauren",
    "logo": "ralph-lauren.png",
    "amazon": GlobalConstants.FILTER_AVAILABLE,
    "sizes": [
      { "size": "Newborn",   "minHeight": 0,    "maxHeight": 21,   "minWeight": 0,    "maxWeight": 10 },
      { "size": "3 Months",  "minHeight": 21,   "maxHeight": 24,   "minWeight": 10,   "maxWeight": 14 },
      { "size": "6 Months",  "minHeight": 24.5, "maxHeight": 27,   "minWeight": 14.5, "maxWeight": 18.5 },
      { "size": "9 Months",  "minHeight": 27.5, "maxHeight": 29,   "minWeight": 19,   "maxWeight": 22 },
      { "size": "12 Months", "minHeight": 29.5, "maxHeight": 31,   "minWeight": 22.5, "maxWeight": 25 },
      { "size": "18 Months", "minHeight": 31.5, "maxHeight": 33,   "minWeight": 25.5, "maxWeight": 27.5 },
      { "size": "24 Months", "minHeight": 33.5, "maxHeight": 35.5, "minWeight": 28,   "maxWeight": 30 },
      { "size": "2/2T",      "minHeight": 34.5, "maxHeight": 36.5, "minWeight": 29,   "maxWeight": 31 },
      { "size": "3/3T",      "minHeight": 37,   "maxHeight": 39.5, "minWeight": 32,   "maxWeight": 35 },
      { "size": "4/4T",      "minHeight": 40,   "maxHeight": 42.5, "minWeight": 36,   "maxWeight": 40 },
      { "size": "5",         "minHeight": 43,   "maxHeight": 45.5, "minWeight": 40,   "maxWeight": 44 },
      { "size": "6",         "minHeight": 46,   "maxHeight": 48.5, "minWeight": 45,   "maxWeight": 49 },
      { "size": "7",         "minHeight": 49,   "maxHeight": 51.5, "minWeight": 49,   "maxWeight": 55 },
    ]
  },
];

export default brands;



/** WEBPACK FOOTER **
 ** ./src/data/clothing-brands.js
 **/